import * as d3 from 'd3-selection'

/*
 * Shortens a text label if its length exceeds the `maxWidth`
 */
export default function (selection, maxWidth) {
  selection.each(function () {
    let text = d3.select(this)
      , words = text.text().split(/\s+/)
      , ellipsis = text.text('')
                       .append('tspan')
                       .text('...')
      , width = maxWidth - ellipsis.node().getComputedTextLength()
      , totalWords = words.length
      , tspan = text.insert('tspan', ':first-child')
                    .text(words.join(' '))

    while (tspan.node().getComputedTextLength() > width && words.length) {
      words.pop()
      tspan.text(words.join(' '))
    }

    if (!tspan.text()) {
      // We don't have space to show anything
      tspan.remove()
      ellipsis.remove()
    }

    if (words.length === totalWords) {
      // No need for the ellipsis
      ellipsis.remove()
    }
  })
}
